import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAccountReducer from '../reducers/account.reducer';

export const selectState = createFeatureSelector<fromAccountReducer.State>(
  fromAccountReducer.featureKey
);

export const getUserProfile = createSelector(selectState, (state) => state.userProfile);
export const getStudentApplication = createSelector(selectState, (state) => state.studentApplication);
export const getPreEnrollmentRequirements = createSelector(selectState, (state) => state.preEnrollmentRequirements);
export const getAcademicRequirements = createSelector(selectState, (state) => state.academicRequirements);
export const getLatestEnrollmentStatus = createSelector(selectState, (state) => state.latestEnrollmentStatus);
export const getCurriculumCompletion = createSelector(selectState, (state) => state.curriculumCompletion);